import { useQuery } from "@tanstack/react-query";
import * as AgenticV2API from "@/services/api/agentic-v2";
import { missionControlKeys } from "./keys";

export interface UseMissionStepLogOptions {
  missionId: string;
  enabled?: boolean;
}

export function useMissionStepLog({
  missionId,
  enabled = true,
}: UseMissionStepLogOptions) {
  return useQuery({
    queryKey: missionControlKeys.missionStepLog(missionId),
    enabled: enabled && Boolean(missionId),
    queryFn: () => AgenticV2API.getMissionStepLog(missionId),
  });
}

export function invalidateMissionStepLog(
  queryClient: { invalidateQueries: (opts: { queryKey: readonly unknown[] }) => void },
  missionId: string,
) {
  queryClient.invalidateQueries({
    queryKey: missionControlKeys.missionStepLog(missionId),
  });
}
